<template>
  <page-template type="rightpanel">
    <template v-slot:toolbar>
      <tool-bar type="back-arrow" title="Nouvelle action collaborative" linkback="/action-collaborative"></tool-bar>
    </template>
    <template v-slot:central-panel-content>
      <div class="padding-x">
        <div>
          <v-form class="form-new-element">
            <v-container>
              <div>
                <v-select v-model="action.category" :items="actionCategory" item-text="name" item-value="_id" label="Catégorie de l'action" :disabled="opening" outlined></v-select>
                <v-text-field v-model="action.title" label="Titre de l'action" :disabled="opening" outlined></v-text-field>
                <v-text-field v-model="action.description" label="Descriptif de l'action" :disabled="opening" outlined></v-text-field>
                <v-select v-model="action.apartments" :items="recipients" item-text="name" item-value="_id" label="Choisir les destinataires" :disabled="opening" multiple chips deletable-chips outlined></v-select>
                <v-row class="d-flex fill-height no-gutters justify-space-between">
                  <v-col class="d-flex flex-column col-5">
                    <v-text-field v-model="action.cost" label="Points attribués" :disabled="opening" outlined></v-text-field>
                  </v-col>
                  <v-col class="d-flex flex-column col-5">
                    <!-- <v-menu ref="menu" v-model="menu" :close-on-content-click="false"  transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="displayDate" persistent-hint label="Date de l'action" append-icon="mdi-calendar-month-outline" readonly outlined v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker :value="inputDate" @change="saveDate($event)" no-title scrollable>
                        </v-date-picker>
                    </v-menu> -->
                  </v-col>
                </v-row>
                <v-row class="d-flex fill-height no-gutters justify-space-between mb-8">
                  <v-col class="d-flex flex-column col-5">
                    <v-datetime-picker label="Date de début" v-model="dateStart" date-format="dd/MM/yyyy" :disabled="opening">
                      <template slot="dateIcon">
                        <v-icon>mdi-calendar</v-icon>
                      </template>
                      <template slot="timeIcon">
                        <v-icon>mdi-clock-outline</v-icon>
                      </template>
                    </v-datetime-picker>
                  </v-col>
                  <v-col class="d-flex flex-column col-5">
                    <v-datetime-picker label="Date de fin" v-model="dateEnd" date-format="dd/MM/yyyy" :disabled="opening">
                      <template slot="dateIcon">
                        <v-icon>mdi-calendar</v-icon>
                      </template>
                      <template slot="timeIcon">
                        <v-icon>mdi-clock-outline</v-icon>
                      </template>
                    </v-datetime-picker>
                  </v-col>
                </v-row>
                <div class="add-file">
                    <v-file-input v-model="newImages" type="file" @change="uploadImages()" v-if="!opening === true" multiple placeholder="Ajouter une photo" outlined dense prepend-icon=""></v-file-input>
                    <div v-for="(image, index) in images" :key="image.id" class="added-file">
                        <v-icon @click="deleteImage(index)" v-if="!opening === true">mdi-close</v-icon>
                        <img :src="image.link" alt="">
                    </div>
                </div>
              </div>
              <div v-if="!opening === true" class="d-flex justify-center">
                <v-btn @click="save(false)" class="mt-4 mx-4 primary-button outlined">Enregistrer</v-btn>
                <v-btn @click="save(true)" class="mt-4 mx-4 primary-button">Publier</v-btn>
              </div>
            </v-container>
          </v-form>
        </div>
      </div>
    </template>
    <template v-slot:right-panel-content>
      <guide-creation
        title="Aide a la création d’action"
        text="Le titre doit être court. Soyez précis sur le descriptif. Les photos ne doivent pas peser plus de 5 Mo."
      ></guide-creation>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import guideCreation from '@/components/GuideCreation.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'ActionCollaborativeNew',
    components: { pageTemplate, toolBar, guideCreation },
    props: {
      editing: {
        type: Boolean,
        default: false
      },
      opening: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        newImages: [],
        actionCategory: [],
        recipients: [],
        images: [],
        dateStart: new Date(),
        dateEnd: new Date(),
        action: {
          title: '',
          description: '',
          cost: '',
          category: '',
          apartments: [],
          dateStart: new Date(),
          dateEnd: new Date(),
          images: [],
          activated: false
        },
        menu: false
      }
    },
    async created () {
      try {
        // GET LIST OF COLLABORATIVE ACTIONS CATEGORIES
        const actionCategoriesRes = await axios.get(`${apiURL}/data/ads/category`)
        this.actionCategory = actionCategoriesRes.data.model
        // GET LIST OF RECIPIENTS
        const RecipientsRes = await axios.get(`${apiURL}/data/apartments`)
        this.recipients = RecipientsRes.data.model
        // EDITING OR OPENING - GET PRIZE INFORMATION
        if (this.editing || this.opening) {
          const actionRes = await axios.get(`${apiURL}/collaborative/order/${this.$route.params.id}`)
          this.action = actionRes.data.model
          this.action.id = this.action._id
          this.action.images.forEach(e => {
            this.images.push({ id: e, link: `${apiURL}/files/render/image/${e}` })
          })
          this.action.apartments = this.action.apartments.map(e => {
            return e._id
          })
        }
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    },
    methods: {
      // FORMAT DATE
      saveDate (date) {
        const d = date.getTime()
        return d
      },
      // SUBMIT IMAGE
      async uploadImages () {
        if (!this.newImages.length) return
        try {
          this.$store.dispatch('loading')
          const formData = new FormData()
          for (let i = 0; i < this.newImages.length; i++) {
            formData.append('images', this.newImages[i])
          }
          const imageRes = await axios.post(`${apiURL}/files/upload/images`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          imageRes.data.model.ids.forEach(e => {
            this.images.push({ id: e, link: `${apiURL}/files/render/image/${e}` })
          })
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.newImages = []
          this.$store.dispatch('stop_loading')
        }
      },
      // DELETE IMAGE
      deleteImage (index) {
        this.images.splice(index, 1)
      },
      // DRAFT, PUBLISH OR EDIT NEW ACTION
      async save (isDraft, redirect = true) {
        this.$store.dispatch('loading')
        try {
          this.action.dateStart = this.saveDate(this.dateStart)
          this.action.dateEnd = this.saveDate(this.dateEnd)
          this.action.images = this.images.map(e => { return e.id })
          this.action.activated = isDraft
          if (!this.editing) {
            await axios.post(`${apiURL}/collaborative/order`, this.action)
          } else {
            await axios.put(`${apiURL}/collaborative/order`, { id: this.action._id, payload: this.action })
          }
          if (redirect) {
            this.$router.push('/action-collaborative')
          }
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      }
    }
  }
</script>